import { render, staticRenderFns } from "./FabButton.vue?vue&type=template&id=120c582a&scoped=true"
import script from "./FabButton.vue?vue&type=script&lang=js"
export * from "./FabButton.vue?vue&type=script&lang=js"
import style0 from "./FabButton.vue?vue&type=style&index=0&id=120c582a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120c582a",
  null
  
)

export default component.exports